<template>
    <div class="departDetail">
        <div class="main-content">
            <breadItem :title1="breadTitle1" :title2="breadTitle2" :link1="breadLink1" :link2="breadLink2"></breadItem>
            <div class="depart-info clearfix">
                <div class="img-left fl">
                    <img :src="depart.img" :alt="depart.name" class="img-responsive">
                </div>
                <div class="img-right fl">
                    <div class="title fs24 fwb pt20 mb40">{{depart.name}}</div>
                    <div class="contents pre-wrap" v-html="depart.content"></div>
                </div>
            </div>
            <div class="depart-title fs24 color-blank" v-if="dataList.length>0">科室医生</div>
            <div class="main-ul">
                <div class="tab-content" v-for="(item,index) in dataList" :key="index">
                    <div class="img-left fl">
                        <img :src="item.img" :alt="item.name" class="img-responsive">
                    </div>
                    <div class="img-right fl">
                        <div class="title fs18 color-blank"><span class="mr40 fwb">{{item.name}}</span><span class="source">{{item.position}}</span></div>
                        <div class="pt10 mb10 depart fs14 color-blank">{{item.departmentstr}}</div>
                        <div class="clearfix describe-box">
                            <div class="describe fs14 txt_limit3">{{item.description}}</div>
                        </div>
                        <div class="reserve fs18 fwb tc" v-if="item.allow_appoint == 1" @click="goReverve(item)" >预约</div>
                        <div class="detail-arrow tc" @click="goDoctorDetail(item.id)">详情<img src="../../assets/images/branch-arrow-right.png" alt=""></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import breadItem from '@/components/breadItem'

export default {
    props: {

    },
    data() {
        return {
            depart:'',
            dataList:[],
            short_name:this.$route.params.short_name,
            departId: this.$route.params.departId,
            breadTitle1:'科室介绍',
            breadTitle2:'科室详情',
            breadLink1:'/depart/'+this.$route.params.short_name+'.html',
            breadLink2:''
        };
    },
    computed: {

    },
    created() {
       this.getDepartmentDetail();
       this.getDoctorList();
    },
    mounted() {

    },
    watch: {
        $route(to,from){
            this.short_name=to.params.short_name;
            sessionStorage.setItem('english_short_name',this.short_name);
            this.getDepartmentDetail();
            this.getDoctorList();
        }
    },
    methods: {
        goDoctorDetail(id){
            this.$router.push('/doctorsDetail/'+this.short_name+'/'+id+'.html');
        },
        getDoctorList(){
            this.$axios.post(this.api.doctor.list+'?perpage=1000'+'&page=1',{
                department_id:this.departId,
                doctor_name:''
            },res =>{
                this.dataList=res.data;
            },);
        },
        getDepartmentDetail(){
            this.$axios.post(this.api.department.detail,{department_id:this.departId},res =>{
                this.depart=res.data;
            })
        },
        goReverve:function(item){
            this.$router.push('/doctorsReserve/'+this.short_name+'/'+item.hospital_id+'/'+item.sub_hospital_id+'/'+item.name+'.html');
        },
    },
    components: {
       breadItem
    },
};
</script>

<style scoped>
.article-title{color:#4A90E2;}
.depart-info .img-left{width:400px;height:400px;margin-right:40px;}
.depart-info .img-right{width:720px;}
.depart-info .img-right .title{height:33px;color:rgba(74,144,226,1);line-height:33px;}
.depart-info .img-right .content{height:290px;line-height:20px;}
.depart-title{padding:40px 0 20px;line-height:33px;}
.tab-content{margin-bottom:20px;height:200px;padding:40px 20px 35px;background:rgba(255,255,255,1);box-shadow:0px 0px 10px 0px rgba(13,52,130,0.1);border-radius:5px;}
.tab-content:hover{box-shadow:0px 0px 10px 0px rgba(13,52,130,0.4);}
.tab-content .img-left{width:120px;height:120px;margin-right:20px;}
.tab-content .img-right{width:1020px;position: relative;}
.tab-content .img-right .title{line-height:25px;}
.tab-content .img-right .describe-box{color:#666;line-height:20px;height:60px;position: relative;}
.tab-content .img-right .describe{width:860px;}
.tab-content .img-right .detail-arrow{position:absolute;top:75px;right:0;border-radius:5px;
border:1px solid #EBEBED;height:40px;line-height:40px;width:100px;}
.tab-content .reserve{position:absolute;top:20px;right:0;color:#fff;width:100px;height:40px;line-height:40px;background:rgba(74,144,226,1);border-radius:5px;}
</style>



// WEBPACK FOOTER //
// src/view/depart/detail.vue